import React from 'react'
import Retailer from './Retailer'
import CtaSection from '../CtaSection/CtaSection'

export default function RetailerPage() {
  return (
      <div>
      <Retailer />
      <CtaSection/>
    </div>
  )
}
